import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, DecimalPipe } from '@angular/common';
import { loadFeedback } from '../../state/feedback/feedback.actions';
import { selectAllFeedback } from '../../state/feedback/feedback.selector';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-ratings-widget',
  standalone: true,
  templateUrl: './ratings-widget.component.html',
  styleUrl: './ratings-widget.component.css',
  imports: [MatCardModule, MatIconModule, CommonModule, DecimalPipe, RouterLink, MatButtonModule],
})
export class RatingsWidgetComponent implements OnInit {
  averageRating$: Observable<number | null>;
  ratingsCount$: Observable<number>;
  stars = [1, 2, 3, 4, 5];
  Math = Math;

  constructor(private store: Store) {
    this.averageRating$ = this.store.select(selectAllFeedback).pipe(
      map(feedbacks => {
        const ratings = (feedbacks || [])
          .map(f => f.rating?.value)
          .filter(r => typeof r === 'number');
        if (!ratings.length) return null;
        const avg = ratings.reduce((a, b) => a + b, 0) / ratings.length;
        return avg;
      })
    );
    this.ratingsCount$ = this.store.select(selectAllFeedback).pipe(
      map(feedbacks => (feedbacks || [])
        .map(f => f.rating?.value)
        .filter(r => typeof r === 'number').length)
    );
  }

  ngOnInit(): void {
    this.store.dispatch(loadFeedback());
  }

  getRatingColor(avg: number | null): string {
    if (avg === null) return '';
    if (avg < 2.5) return 'low';
    if (avg < 4) return 'medium';
    return 'high';
  }
}
